export const boardsAddButtonTexts = {
  BOARD: 'AddBoard',
  BASIC_BOARD: 'AddBoard',
  COUNCIL: 'AddCouncil',
};
